(function () {
  function init(root) {
    const viewport = root.querySelector('[data-logo-viewport]');
    const track = root.querySelector('[data-logo-track]');
    const btnL = root.querySelector('.logo-catbar__arrow--left');
    const btnR = root.querySelector('.logo-catbar__arrow--right');

    if (!viewport || !track || !btnL || !btnR) return;

    const getStep = () => {
      const item = track.querySelector('.logo-catbar__item');
      if (!item) return 300;
      const gap = parseFloat(getComputedStyle(track).gap || '0') || 0;
      return item.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      const x = viewport.scrollLeft;
      const overflow = maxScroll > 2;

      root.classList.toggle('is-overflowing', overflow);
      track.classList.toggle('is-centered', !overflow);

      btnL.disabled = !overflow || x <= 2;
      btnR.disabled = !overflow || x >= maxScroll - 2;
    };

    btnL.addEventListener('click', () => viewport.scrollBy({ left: -getStep(), behavior: 'smooth' }));
    btnR.addEventListener('click', () => viewport.scrollBy({ left:  getStep(), behavior: 'smooth' }));
    viewport.addEventListener('scroll', update, { passive: true });

    new ResizeObserver(update).observe(viewport);
    window.addEventListener('load', update);
    update();
  }

  function boot() {
    document.querySelectorAll('.logo-catbar').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', boot);
})();
